export enum LocalStorageKeys {
    LAST_VISIT = 'last_visit',
}